import { SET_TEAM } from './constants';

export const setTeam = team => {
    return {
        type: SET_TEAM,
        payload: team,
    };
};
